import { getRoleDetail } from "_services";
import { ButtonHeading, CommonInput, CommonTextarea } from "components";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import StorageService from "utils/StorageServices/StorageServices";
import { NewRole } from ".";

const ViewRole = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [roleDetails, setRoleDetails] = useState();
  const companyId = StorageService.getCompanyId();

  useEffect(() => {
    getDetailsOfRole();
  }, []);

  const getDetailsOfRole = async () => {
    const payload = {
      company_id: companyId,
      role_id: atob(id),
    };
    try {
      const resp = await getRoleDetail(payload);
      if (resp?.responseCode === 200) {


        setRoleDetails(resp.data);
      } else {
      }
    } catch (error) {
      toast.error(error);
    }
  };


  return (
    <div className="__profilCmp_main setting-nw-parentBx">
      <ButtonHeading
        title={"View Role"}
        className="commonHeading_title"
        //  buttonTitle={"Add Role"}
        //  onClick={()=>navigate(`/setting/role/addrole`)}
        isBackButton={true} onClickBackButton={(() => navigate(-1))} />


      <div className="_addContainer">
        <div className="_addRl_bx">
          <div className="_addRlHead">Role Details</div>

          <div className="_addRl_tableBx">
            <div className="_rlsInputs_bx">
              <div className="addRl_inputOtr">
                <CommonInput
                  type="text"
                  placeholder="Role Name"
                  label="Role Name"
                  value={roleDetails?.role_name}
                  disabled={true}
                />
              </div>

              <div className="addRl_inputOtr">
                <CommonTextarea
                  placeholder="Description"
                  label="Description"
                  value={roleDetails?.description}
                  disabled={true}
                />
              </div>
            </div>
            <NewRole roleModules={roleDetails?.permission}
              setRoleModules={(e) => { }}
              loading={true} />

          </div>
        </div>
      </div>

    </div>
  );
};

export default ViewRole;
